<section class="teams_Section">
    <div class="col-12 col-lg-12 col-md-12 col-xs-12 nopad clearfix">
        <h3 class="topSectionHeading">Team</h3>
    </div>
    <div class="col-12 col-lg-12 col-md-12 col-xs-12 nopad clearfix teamsContainer">
        <div class="col-12 col-lg-5 col-md-5 col-xs-12 nopad floatLeft teamsLeftContainer">
            <div *ngFor="let element of leadership">
                <div class="polygonImgContainer" *ngIf="element.profile_type=='Special'" style="margin-bottom: 50px;">
                    <div class="hexa">
                        <img src="{{baseUrl}}/homepage/leadership/{{element.profile}}" alt="" />
                    </div>     
                    <h4 class="memberName">{{element.name}}</h4>
                    <p class="memberDesignation">{{element.designation}}</p>       
                </div>            
            </div>
        </div>
        <div class="col-12 col-lg-7 col-md-7 col-xs-12 nopad floatLeft teamsRightContainer">
            <div *ngFor="let element of leadership">
                <div class="TeamListItem" *ngIf="element.profile_type=='Normal'">
                    <div class="polygonImgContainer">
                        <div class="hexa">
                            <img src="{{baseUrl}}/homepage/leadership/{{element.profile}}" alt="" />
                        </div>            
                    </div>
                    <h4 class="memberName">{{element.name}}</h4>
                    <p class="memberDesignation">{{element.designation}}</p>
                </div>      
            </div>
            <!-- <div *ngFor="let element of leadership">
                <div class="TeamListItem">
                    <div class="polygonImgContainer" *ngIf="element.designation=='Data Analyst'">
                        <div class="hexa">
                            <img src="{{baseUrl}}/homepage/leadership/{{element.profile}}" alt="" />
                        </div>            
                    </div>
                    <h4 class="memberName" *ngIf="element.designation=='Data Analyst'">{{element.name}}</h4>
                    <p class="memberDesignation" *ngIf="element.designation=='Data Analyst'">{{element.designation}}</p>
                </div>      
            </div>
            <div *ngFor="let element of leadership">
            <div class="TeamListItem" style="margin-left: 0; margin-top: 50%;">
                <div class="polygonImgContainer" *ngIf="element.designation=='Program Coordinator'">
                    <div class="hexa">
                        <img src="{{baseUrl}}/homepage/leadership/{{element.profile}}" alt="" />
                    </div>            
                </div>
                <h4 class="memberName" *ngIf="element.designation=='Program Coordinator'">{{element.name}}</h4>
                <p class="memberDesignation" *ngIf="element.designation=='Program Coordinator'">{{element.designation}}</p>
            </div>      
            </div>
            <div *ngFor="let element of leadership">
            <div class="TeamListItem" style="margin-left: 35px; margin-top: 38%;">
                <div class="polygonImgContainer" *ngIf="element.designation=='IT Consultant'">
                    <div class="hexa">
                        <img src="{{baseUrl}}/homepage/leadership/{{element.profile}}" alt="" />
                    </div>            
                </div>

                <h4 class="memberName"*ngIf="element.designation=='IT Consultant'">{{element.name}}</h4>
                <p class="memberDesignation" *ngIf="element.designation=='IT Consultant'">{{element.designation}}</p>
            </div>      
            </div> -->
        </div>
    </div>
</section>
<div class="bottomContainer"><div class="container bottomDesign"></div></div>

<!-- <section class="FirstScroll_Section" style="background-color: rgb(233, 230, 230);">
    <div class="container nopad">
<p class="heading">Meet the individuals who bring unique perspectives, broad experience acquired through close collaborations, and deep insight to our work.</p>
        <div class="row">

          <div class="col-sm-4 py-3 py-sm-0">
                <img src="assets/img/profile/adam.jpg" class="imageLayout" >
                <a href="" class="card-text">Prof. Anil D. Sahasrabudhe</a>
                <p class="subtitle">Chairman</p>
                <span class="action">
                    <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                    <a href=""><i class="fa fa-plus-circle"></i></a>
                </span>
                <hr/>
            </div>

          <div class="col-sm-4 py-3 py-sm-0">
                    <img src="assets/img/profile/michael.jpg" class="imageLayout">
                    <a href="" class="card-text">Prof. M.P. Poonia</a>
                    <p class="subtitle">Vice Chairman</p>
                    <span class="action">
                        <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                        <a href=""><i class="fa fa-plus-circle"></i></a>
                    </span>
                    <hr/>
          </div>

          <div class="col-sm-4 py-3 py-sm-0">
                    <img src="assets/img/profile/bruno.jpg" class="imageLayout">
                    <a href="" class="card-text">Prof. Rajive Kumar</a>
                    <p class="subtitle">Member Secretary</p>
                    <span class="action">
                        <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                        <a href=""><i class="fa fa-plus-circle"></i></a>
                    </span>
                    <hr/>
          </div>
          
        </div>
    </div>
</section>

    <div class="container nopad">
        <h1 class="SectionHeading">CIO/Adviser I/CCO</h1>
        <div class="row">
            
          <div class="col-sm-4 py-3 py-sm-0">
                <img src="assets/img/profile/adam.jpg" class="imageLayout" >
                <a href="" class="card-text">Dr. Abhay Jere</a>
                <p class="subtitle">Chief Innovation Officer</p>
                <span class="action">
                    <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                    <a href=""><i class="fa fa-plus-circle"></i></a>
                </span>
                <hr/>
            </div>

          <div class="col-sm-4 py-3 py-sm-0">
                    <img src="assets/img/profile/michael.jpg" class="imageLayout">
                    <a href="" class="card-text">Prof. Dileep N. Malkhede</a>
                    <p class="subtitle">Adviser–I</p>
                    <span class="action">
                        <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                        <a href=""><i class="fa fa-plus-circle"></i></a>
                    </span>
                    <hr/>
          </div>

          <div class="col-sm-4 py-3 py-sm-0">
                    <img src="assets/img/profile/bruno.jpg" class="imageLayout">
                    <a href="" class="card-text">Prof. Rajendra B Kakde</a>
                    <p class="subtitle">Adviser-I</p>
                    <span class="action">
                        <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                        <a href=""><i class="fa fa-plus-circle"></i></a>
                    </span>
                    <hr/>
          </div>

          <div class="col-sm-4 py-3 py-sm-0">
            <img src="assets/img/profile/bruno.jpg" class="imageLayout">
            <a href="" class="card-text">Dr Buddha Chandrashekhar</a>
            <p class="subtitle">Chief Coordinating Officer</p>
            <span class="action">
                <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                <a href=""><i class="fa fa-plus-circle"></i></a>
            </span>
            <hr/>
          </div>
          
        </div>
    </div>


    <div class="container nopad">
        <h1 class="SectionHeading">Adviser II</h1>
        <div class="row">
            
          <div class="col-sm-4 py-3 py-sm-0">
                <img src="assets/img/profile/adam.jpg" class="imageLayout" >
                <a href="" class="card-text">Prof. R.Hariharan</a>
                <p class="subtitle">Adviser-II</p>
                <span class="action">
                    <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                    <a href=""><i class="fa fa-plus-circle"></i></a>
                </span>
                <hr/>
            </div>

          <div class="col-sm-4 py-3 py-sm-0">
                    <img src="assets/img/profile/michael.jpg" class="imageLayout">
                    <a href="" class="card-text">Dr. Neeraj Saxena</a>
                    <p class="subtitle">Adviser-II</p>
                    <span class="action">
                        <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                        <a href=""><i class="fa fa-plus-circle"></i></a>
                    </span>
                    <hr/>
          </div>
         
        </div>
    </div>



    <div class="container nopad">
        <h1 class="SectionHeading">Directors</h1>
        <div class="row">

      <div class="col-sm-4 py-3 py-sm-0">
                <img src="assets/img/profile/michael.jpg" class="imageLayout">
                <a href="" class="card-text">Dr. N.H. Siddalingaswamy</a>
                <p class="subtitle">Director</p>
                <span class="action">
                    <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                    <a href=""><i class="fa fa-plus-circle"></i></a>
                </span>
                <hr/>
      </div>

      <div class="col-sm-4 py-3 py-sm-0">
                <img src="assets/img/profile/michael.jpg" class="imageLayout">
                <a href="" class="card-text">Col. B Venkat</a>
                <p class="subtitle">Director</p>
                <span class="action">
                    <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
                    <a href=""><i class="fa fa-plus-circle"></i></a>
                </span>
                <hr/>
      </div>

      <div class="col-sm-4 py-3 py-sm-0">
        <img src="assets/img/profile/bruno.jpg" class="imageLayout">
        <a href="" class="card-text">Dr. R. K. Soni</a>
        <p class="subtitle">Director</p>
        <span class="action">
            <a href=""><i class="fa fa-envelope"></i></a> &nbsp;&nbsp;
            <a href=""><i class="fa fa-plus-circle"></i></a>
        </span>
        <hr/>
        </div>
        </div>
    </div> -->
